//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'AlertInfo',

    props: {
        message: {
            type: String,
            required: true,
        },

        dismissible: {
            type: Boolean,
            required: false,
            default: true,
        },

        size: {
            type: String,
            required: false,
            default: 'sm',
            validator: (value) => ['sm', 'md'].includes(value),
        },

        icon: {
            type: String,
            required: false,
            default: 'info-icon',
        },
    },

    computed: {
        iconSize() {
            return {
                sm: 'h-5 w-5',
                md: 'h-7 w-7',
            }[this.size];
        },

        textSize() {
            return {
                sm: 'text-sm',
                md: 'text-md',
            }[this.size];
        },
    },
};
